var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWhatsappWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.694,
    height: 19.789,
    viewBox: "0 0 19.694 19.789",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.075,2.876A9.808,9.808,0,0,0,1.641,14.708L.25,19.789l5.2-1.364a9.8,9.8,0,0,0,4.686,1.194h0A9.81,9.81,0,0,0,17.075,2.876ZM10.138,17.963h0a8.14,8.14,0,0,1-4.148-1.136l-.3-.177L2.6,17.459l.823-3.008-.194-.308a8.15,8.15,0,1,1,6.9,3.819Zm4.471-6.1c-.245-.123-1.45-.715-1.674-.8s-.388-.122-.551.123-.633.8-.776.961-.286.184-.531.061a6.692,6.692,0,0,1-1.97-1.216,7.391,7.391,0,0,1-1.363-1.7c-.143-.245,0-.365.107-.5a6.931,6.931,0,0,0,.612-.838.451.451,0,0,0-.021-.429C8.382,7.4,7.892,6.2,7.687,5.706s-.4-.413-.551-.421-.306-.009-.47-.009a.9.9,0,0,0-.653.307,2.748,2.748,0,0,0-.857,2.044,4.766,4.766,0,0,0,1,2.535,10.922,10.922,0,0,0,4.186,3.7,14.024,14.024,0,0,0,1.4.516,3.359,3.359,0,0,0,1.543.1,2.524,2.524,0,0,0,1.654-1.165,2.047,2.047,0,0,0,.143-1.165C15.017,12.043,14.854,11.981,14.609,11.859Zm0,0",
    transform: "translate(-0.25)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsappWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsapp_white.1b5b2d70.svg";
export { ForwardRef as ReactComponent };